module.exports = __webpack_public_path__ + "fonts/montserrat-bold-webfont.475d48b.woff2";